import "../ui/styles/trade.css";
import Sidebar from "../ui/uiElements/Sidebar.component";
import { NavLink, Outlet } from "react-router-dom";

function TardeJournal() {
  return (
    <div className="board-container">
      <Sidebar title="Trade Journal">
        <li>
          <NavLink to="/trade-journal/all-trades" className="styled-nav-link">
            Trade Journal
          </NavLink>
          <NavLink to="/trade-journal/add-trade" className="styled-nav-link">
            Add Trade
          </NavLink>
        </li>
      </Sidebar>
      <div className=" mt-5 content-board overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}

export default TardeJournal;
